import { render, staticRenderFns } from "./PurchaseOption.vue?vue&type=template&id=ca702230&scoped=true&"
import script from "./PurchaseOption.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOption.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOption.vue?vue&type=style&index=0&id=ca702230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca702230",
  null
  
)

export default component.exports